import { AppStateContext } from '#/state'
import { useContext } from 'react'

export const useLogoNavigationLink = () => {
  const appStateContext = useContext(AppStateContext)

  if (!appStateContext) {
    throw new Error('useLogoNavigationLink hook needs to be used within AppStateContext')
  }

  const enableLogoNavigationLink = () => {
    appStateContext.dispatch({ type: 'ENABLE_LOGO_NAVIGATION_LINK' })
  }

  const disableLogoNavigationLink = () => {
    appStateContext.dispatch({ type: 'DISABLE_LOGO_NAVIGATION_LINK' })
  }

  const logoNavigationLinkDisabled = appStateContext.state.logoNavigationLinkDisabled || false

  return {
    enableLogoNavigationLink,
    disableLogoNavigationLink,
    logoNavigationLinkDisabled
  }
}
